















































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class SzsxShijuangailan extends Vue {
  @Prop()
  private test;
  @Prop()
  private exam;
  @Prop()
  private leftTime;
  @Prop()
  private answers;
  private get user() {
    return this.$store.state.user;
  }
  private jump(index) {
    this.$emit("jump", index);
  }
}
